module.exports = __webpack_public_path__ + "static/img/preview-video1.df83e64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blast/preview-video1.jpg
// module id = TdMX
// module chunks = 1